import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  icon,
  moreTo,
  moreLabel = '查看全部',
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="flex items-center gap-3">
        <span className="w-1.5 h-7 rounded-full bg-accent-500"></span>
        <div>
          <h2 className="flex items-center gap-2 text-lg md:text-xl font-bold text-foreground-950">
            {icon ? (
              <span className="w-6 h-6 flex items-center justify-center text-primary-600">
                <i className={`${icon} text-xl`}></i>
              </span>
            ) : null}
            {title}
          </h2>
          {subtitle ? (
            <p className="mt-0.5 text-xs md:text-sm text-foreground-500">{subtitle}</p>
          ) : null}
        </div>
      </div>
      {moreTo ? (
        <Link
          to={moreTo}
          className="shrink-0 flex items-center gap-1 whitespace-nowrap text-sm text-foreground-500 hover:text-primary-700 transition-colors"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      ) : null}
    </div>
  );
}